import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  GetStakingRiskProductsUserInfoWithNoSelectedThunk,
  StakingRiskProductsThunk,
} from "../../Thunks/StakingRiskThunk";
import { StakingProductDropDown } from "../../Components/StakingRiskCard/StakingProductDropDown";
import styles from "./addStakingRisk.module.css";

export function AddStakingRiskModal({
  modalClose,
  title,
  onProductSelect,
  onSaveProduct,
  stakedAmount,
  setStakedAmount,
}) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openSave, setOpenSave] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const dispatch = useDispatch();

  const stakingRiskProductsListWithNoSelected = useSelector((state) => {
    return state.StakingRiskReducer.stakingRiskProductsListWithNoSelected;
  });
  const userStakingProductCreatedByIDSuccess = useSelector((state) => {
    return state.StakingRiskReducer.userStakingProductCreatedByIDSuccess;
  });

  const createProductError = useSelector((state) => {
    return state.StakingRiskReducer.createProductError;
  });
  const loading = useSelector((state) => state.StakingRiskReducer.loading);

  useEffect(() => {
    dispatch(
      GetStakingRiskProductsUserInfoWithNoSelectedThunk({ selected: false }),
    );
  }, [userStakingProductCreatedByIDSuccess]);

  useEffect(() => {}, [windowWidth]);

  useEffect(() => {
    !stakingRiskProductsListWithNoSelected?.length &&
      dispatch(StakingRiskProductsThunk());
  }, []);

  const dropdownOptions = stakingRiskProductsListWithNoSelected.map(
    (product) => ({
      value: product?.stakingRisk?.id,
      label: (
        <div className="dropdown__option">
          <div className="dropdown__option__title">
            {product?.stakingRisk.name}
          </div>
        </div>
      ),
      raw: product?.stakingRisk,
    }),
  );

  const formatWithCommas = (value) => {
    const num = value.replace(/[^\d]/g, "");
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleChange = (e) => {
    const raw = e.target.value;
    const numericOnly = raw.replace(/[^\d]/g, "");
    setStakedAmount(formatWithCommas(numericOnly));
  };
  return (
    <div className={`${styles.addStakingWrapper} card  new__defi empty defi`}>
      <div className="card__header">
        <div className="row">
          <h2 className="card__title">Choose Product</h2>
          <div
            className="close__card__content"
            onClick={() => {
              modalClose(false);
            }}
          >
            <span className="card__close">
              <span></span>
              <span></span>
            </span>
          </div>
        </div>
      </div>

      <div className="card__price card__wallet__content">
        <div className="">
          <div className="card__wallet__rates" style={{ marginLeft: "10px" }}>
            <div style={{ marginLeft: "10px", position: "relative" }}>
              <input
                type="text"
                className="card__wallet__input"
                placeholder=""
                value={stakedAmount}
                onChange={handleChange}
                style={{
                  padding: "8px 2px 8px 10px",
                  borderRadius: "6px",
                  border: "navajowhite",
                  width: "100%",
                  background: "transparent",
                  outline: "none",
                  color: "#364048",
                  fontWeight: "bold",
                  textAlign: "right",
                }}
              />
              <span
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "-10px",
                  transform: "translateY(-50%)",
                  color: "#889096",
                  fontWeight: "bold",
                  pointerEvents: "none",
                }}
              >
                Staked
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="card__product__wrapper" style={{ marginTop: "45px" }}>
        <div style={{ display: "flex" }}>
          <div style={{ width: "100%" }}>
            <StakingProductDropDown
              options={dropdownOptions}
              placeholder="Choose Product"
              value={selectedOption}
              onChange={(option) => {
                setSelectedOption(option);
                setSelectedProduct(option.raw);
                onProductSelect?.(option.raw);
              }}
              error={createProductError}
            />
          </div>
        </div>
      </div>

      <div
        className={
          "card__product__stake__block" +
          " " +
          (title === "Staking Risk"
            ? "card__product__stake__block__light_defi"
            : "card__product__stake__block")
        }
      >
        <button className="card__product__stake">Stake</button>
        <button className="card__product__unstacked">Unstake</button>
      </div>

      <div className="card__risk stacking_risk_card__risk">
        <h3 className="card__risk__title">Create Product</h3>
        <div className="card__risk__alert active" style={{ marginTop: "4px" }}>
          <p className="card__risk__alert__title">Alert</p>
          <p className="card__risk__alert__number">0</p>
        </div>
        <div className="card__risk__chart" style={{ visibility: "hidden" }}>
          <div className="card__risk__chart__min">
            <p className="card__risk__chart__number">0</p>
            <p className="card__risk__chart__number__of">of 100</p>
          </div>
        </div>
        <div
          className="card__risk__info"
          style={{ left: "30px", bottom: "-17px" }}
        >
          <i className="icon-info-icon"></i>
        </div>
      </div>
      <div
        className={"add__wallet new add_staking"}
        style={{ bottom: "-22px", left: "-8px" }}
      >
        <div className="add__wallet__btn__bg">
          <div
            className="plus__wrapper"
            onClick={() => {
              setOpenSave(true);
              onSaveProduct?.();

              setSelectedOption(null); // reset dropdown
              setSelectedProduct(null);
            }}
          >
            {loading ? (
              <div className={styles.loader}></div>
            ) : (
              <>
                <span></span>
                <span></span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
